<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		
		<nemunav :list="navList" navBgImg="case" :menutitle="menutitle" @tapMenu="tapMenu"  :navIndex="selectIndex"></nemunav>		
		
		<case1 v-if="selectIndex==0"></case1>
		<case2 v-if="selectIndex==1" :list="list" :total="total" :selectIndex="caseTypeIndex" @changeCaseType="changeCaseType"></case2>
		
		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import {
	  
	} from '@/api/home.js';
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	import nemunav from "@/components/nemunav.vue";
	import case1 from "@/components/case/index1.vue";
	import case2 from "@/components/case/index2.vue";
	import footer1 from "@/components/footer.vue";
	import {
	  caselist,
	} from '@/api/home.js';
	export default {
		components: {
			mobilemenu,
			header1,
			footer1,
			nemunav,
			case1,
			case2,
		},
		data() {
			return {
				pathname: "case",
				menutitle:"项目案例",
				navList:["合作伙伴", "合作案例"],
				selectIndex:0,
				isShowMobile:false,
				list:[],
				pageNum:1,
				total:0,
				caseTypeIndex:0
			}
		},
		created() {
			
			this.selectIndex = this.$route.query.index?this.$route.query.index:0
			this.getcaselist()

		},
		methods: {
			getcaselist() {
				caselist({
				  pageNum: this.pageNum,
					pageSize:10,
					caseType:this.caseTypeIndex+1
				}).then(res => {
				  if (res.data.code == 200) {
				    this.list = res.data.rows
					this.total = res.data.total
				  }
				})
			},
			changeCaseType(e) {
				this.caseTypeIndex = e
				this.getcaselist()
			},
			tapMenu(e) {
				this.selectIndex = e
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px; 
		}
	
	}
</style>
